import { Segmented } from "../../../../ui";
import type { ProductKind } from "../editorModel";

/** Editor §2: Simple / With variants. It only decides whether the variant pickers show; the picks are kept. */
export function TypeSection({ kind, onChange }: { kind: ProductKind; onChange: (kind: ProductKind) => void }) {
  return (
    <section className="editor-section">
      <h3 className="editor-section__title">Type</h3>
      <Segmented<ProductKind>
        ariaLabel="Product type"
        value={kind}
        onChange={onChange}
        options={[
          { value: "simple", label: "Simple" },
          { value: "variants", label: "With variants" },
        ]}
      />
      <p className="editor-hint">
        {kind === "simple"
          ? "One SKU: a bottle, bands, a one-size tee."
          : "Pick values and sizes below: every combination becomes a SKU. Switch off the ones that don't exist."}
      </p>
    </section>
  );
}

export default TypeSection;
